import styled from 'styled-components';
import { Flex, Box } from 'component/base/Grid';
import { Link } from 'react-router-dom';

export const Container = styled(Flex)`
  background-color: ${(props) => props.theme.colors.white};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  min-height: 75px;
`;

Container.defaultProps = {
  width: 1,
  py: '15px',
  justifyContent: 'center',
  flexDirection: 'column',
};

interface IWrapper {
  fixed?: boolean;
}

export const Wrapper = styled(Flex)<IWrapper>`
  ${(props) =>
    props.fixed &&
    `
    margin: 0 auto;
  `};
`;

Wrapper.defaultProps = {
  width: 1,
  px: 2,
  alignItems: 'center',
  flexDirection: 'row',
};

export const Menu = styled(Box)`
  font-size: 0.8em;
  ${(props) => props.theme.text.MainNavItem};
`;

Menu.defaultProps = {
  ml: 'auto',
};

export const PrimaryLink = styled(Link)`
  border: 1px solid ${(props) => props.theme.colors.lightPeriwinkle};
  padding: 10px 1em;
  margin-left: 1em;
  border-radius: 4px;
  position: relative;
  top: -1px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;

  color: ${(props) => props.theme.colors.darkBlue} !important;

  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${(props) => props.theme.colors.darkBlue};
    border-color: ${(props) => props.theme.colors.darkBlue};
    color: #fff !important;
  }
`;
